import {
    GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_SUCCESS,
    GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_FAIL,
    POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_FAIL,
    GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_FAIL,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_FAIL,
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_SUCCESS,
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_FAIL,
    POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_SUCCESS,
    POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_FAIL,
    GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_SUCCESS,
    GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_FAIL,
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_SUCCESS,
    GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_FAIL,
    POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_SUCCESS,
    POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_FAIL,
    POST_TIGERCAT_BURNS_ADD_BASE_CALLER_SUCCESS,
    POST_TIGERCAT_BURNS_ADD_BASE_CALLER_FAIL,
    POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_SUCCESS,
    POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_FAIL,
    GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_SUCCESS,
    GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_FAIL,
    GET_TIGERCAT_BURNS_GET_BASE_CALLERS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BASE_CALLERS_FAIL,
    GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_SUCCESS,
    GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_FAILURE,
    // 
    POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_SUCCESS,
    POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_FAILURE,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_FAIL,
    POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_SUCCESS,
    POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_FAIL,
    GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_SUCCESS,
    GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_FAIL,
    API_POST_TELEMATICS_ACTIVITY_DATA_SUCCESS,
    API_POST_TELEMATICS_ACTIVITY_DATA_FAIL,
    API_GET_TELEMATICS_ACTIVITY_DATA_SUCCESS,
    API_GET_TELEMATICS_ACTIVITY_DATA_FAIL,
    GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_SUCCESS,
    GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_FAIL,
    API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_SUCCESS,
    API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_FAIL,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_FAIL,
    GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_SUCCESS,
    GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_FAIL,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS,
    GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL,
    POST_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS,
    POST_FEEDSTOCK_MOISTURE_CONTENT_FAIL,
    GET_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS,
    GET_FEEDSTOCK_MOISTURE_CONTENT_FAIL,
    GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_SUCCESS,
    GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_FAIL
} from '../../actions/tigercat-burns/types/tigercat-types';

const initialState = {
    biocharVolumes: [],
    biocharMassBags: [],
    bulkFuelDeliveries: [],
    equipmentTransports: [],
    biocharProductionFuelUses: [],
    feedstockProcessingFuel: [],
    propaneRefills: [],
    biocharMoistureContents: [],
    feedstockTransports: [],
    callSubmissionLogs: [],
    baseCallers: [],
    telematicsActivityData: {},
    biocharCollection: [],
    biocharLabSamples: [],
    biocharLabSamplesContaminants: [],
    feedstockMoistureContent: [],
    feedstockMoistureContentAverages: [],
    loading: true,
};

export default function tigercatBurnsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharVolumes: payload
            };
        case GET_TIGERCAT_BURNS_BIOCHAR_VOLUMES_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharCollection: payload
            };
        case GET_TIGERCAT_BURNS_BIOCHAR_COLLECTION_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharMassBags: payload
            };
        case GET_TIGERCAT_GET_BIOCHAR_MASS_BAGS_FAILURE:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_POST_BIOCHAR_MASS_MOISTURE_CONTENT_FAILURE:
            return {
                ...state,
                loading: false
            }
        case POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BULK_FUEL_DELIVERY_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_SUCCESS:
            return {
                ...state,
                loading: false,
                bulkFuelDeliveries: payload
            };
        case GET_TIGERCAT_BURNS_GET_BULK_FUEL_DELIVERY_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_PRODUCTION_FUEL_USE_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharProductionFuelUses: payload
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_PRODUCTION_FUEL_USE_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_SUCCESS:
            return {
                ...state,
                loading: false,
                feedstockProcessingFuel: payload
            };
        case GET_TIGERCAT_BURNS_GET_FEEDSTOCK_PROCESSING_FUEL_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_SUCCESS:
            return {
                ...state,
                loading: false,
                propaneRefills: payload
            };
        case GET_TIGERCAT_BURNS_GET_PROPANE_REFILL_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_SUCCESS:
            return {
                ...state,
                loading: false,
            };
        case POST_TIGERCAT_BURNS_POST_PROPANE_REFILL_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                feedstockTransports: payload
            };
        case GET_TIGERCAT_BURNS_GET_FEEDSTOCK_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_FEEDSTOCK_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_ADD_BASE_CALLER_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_ADD_BASE_CALLER_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_ADD_CALL_SUBMISSION_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_SUCCESS:
            return {
                ...state,
                loading: false,
                callSubmissionLogs: payload
            };
        case GET_TIGERCAT_BURNS_GET_CALL_SUBMISSION_LOG_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BASE_CALLERS_SUCCESS:
            return {
                ...state,
                loading: false,
                baseCallers: payload
            };
        case GET_TIGERCAT_BURNS_GET_BASE_CALLERS_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_MC_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharMoistureContents: payload
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_MC_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharLabSamples: payload
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_EQUIPMENT_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipmentTransports: payload
            };
        case GET_TIGERCAT_BURNS_GET_EQUIPMENT_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false
            };
        case API_GET_TELEMATICS_ACTIVITY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                telematicsActivityData: payload
            };
        case API_GET_TELEMATICS_ACTIVITY_DATA_FAIL:
            return {
                ...state,
                loading: false
            };
        case API_POST_TELEMATICS_ACTIVITY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                telematicsActivityData: payload
            };
        case API_POST_TELEMATICS_ACTIVITY_DATA_FAIL:
            return {
                ...state,
                loading: false
            };
        case API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_SUCCESS: {
            const { data } = payload;
            const equipmentId = data.data[0]?.equipmentId;
            const existing = state.telematicsActivityData
            const updated = {
                ...existing,
                data: {
                    ...existing.data,
                    telematics_data: {
                        ...existing.data.telematics_data,
                        [equipmentId]: {
                            data: data.data,
                            pagination: data.pagination
                        }
                    }
                }
            }
            return {
                ...state,
                loading: false,
                telematicsActivityData: updated
            };
        } case API_GET_TELEMATICS_ACTIVITY_DATA_FOR_EQUIPMENT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_DOWNLOAD_DOCUMENT_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_TIGERCAT_BURNS_POST_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_SUCCESS:
            return {
                ...state,
                biocharLabSamplesContaminants: payload,
                loading: false
            };
        case GET_TIGERCAT_BURNS_GET_BIOCHAR_LAB_SAMPLES_CONTAMINANTS_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_FEEDSTOCK_MOISTURE_CONTENT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_FEEDSTOCK_MOISTURE_CONTENT_SUCCESS:
            return {
                ...state,
                feedstockMoistureContent: payload,
                loading: false
            };
        case GET_FEEDSTOCK_MOISTURE_CONTENT_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_SUCCESS:
            return {
                ...state,
                feedstockMoistureContentAverages: payload,
                loading: false
            };
        case GET_FEEDSTOCK_MOISTURE_CONTENT_AVERAGES_FAIL:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}